import React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import '../style/Components.css';

interface CircularProgressWithLabelProps extends CircularProgressProps {
  value: number;
}

const CircularProgressWithLabel: React.FC<CircularProgressWithLabelProps> = ({ value, size = 100, ...other }) => {
  return (
    <Box
      className='circularProgressWithLabel-box'
      sx={{
        width: size,
        height: size,
      }}
    >
      <CircularProgress
        variant="determinate"
        className='primaryBlueColor'
        value={value}
        size={size}
        thickness={5}
        {...other}
      />
      <Box className='circularProgressWithLabel-content'>
        <Typography variant="h4" className='primaryBlueColor'>{`${Math.round(value)}%`}</Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressWithLabel;
